export default __webpack_public_path__ + "static/media/disconnect-icon.58439110.svg";